export const DAILY_LIMIT_EXCEEDED_DIALOG = 'DailyLimitExceededDialog';
export const DISCONNECTED_FOR_INACTIVITY_DIALOG = 'DisconnectedForInactivityDialog';
export const DISCONNECTED_FROM_OPERATOR_DIALOG = 'DisconnectedFromOperatorDialog';
export const DISCONNECTED_SESSION_DIALOG = 'DisconnectedSessionDialog';
export const DISCONNECTION_DIALOG = 'DisconnectionDialog';
export const GENERIC_DIALOG = 'GenericDialog';
export const GEOLOCATION_ERROR_DIALOG = 'GeolocationErrorDialog';
export const LOW_BALANCE_DIALOG = 'LowBalanceDialog';
export const LOW_REAL_BALANCE_DIALOG = 'LowRealBalanceDialog';
export const NO_VIDEO_DIALOG = 'NoVideoDialog';
export const OPERATOR_ERROR_DIALOG = 'OperatorErrorDialog';
export const REALITY_CHECK_DIALOG = 'RealityCheckDialog';
export const RECONNECTING_SOCKET_DIALOG = 'ReconnectingSocketDialog';
export const REGULATIONS_DIALOG = 'RegulationsDialog';
export const REGULATIONS_OSS_DIALOG = 'RegulationsOSSDialog';
export const TABLE_CLOSED_DIALOG = 'TableClosedDialog';
export const UKGC_DIALOG = 'UKGC_DIALOG';
export const VIDEO_ERROR_DIALOG = 'VideoErrorDialog';
export const RETAIL_ROUND_CANCELED_DIALOG = 'RetailRoundCanceledDialog';
export const RECONNECTING_SCREEN_DIALOG = 'ReconnectingSocketScreen';
export const PLAYER_NR_TABLE_LIMIT_REACHED_DIALOG = 'PlayerNrTableLimitReachedDialog';
export const WELCOME_DIALOG = 'WelcomeDialog';
export const BONUS_WHEEL_INSUFFICIENT_BALANCE_DIALOG = 'BonusWheelInsufficientBalanceDialog';
